"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragConstraintUtils = void 0;
const gl_matrix_1 = require("gl-matrix");
class DragConstraintUtils {
    // #endregion Properties (1)
    // #region Public Static Accessors (1)
    static get instance() {
        return this._instance || (this._instance = new this());
    }
    // #endregion Public Static Accessors (1)
    // #region Public Methods (2)
    /**
     * Intersect the drag constraints with the provided ray.
     * Returns a transformation matrix with the closest drag constraint.
     *
     * @param dragConstraints
     * @param viewport
     * @param node
     * @param ray
     * @returns
     */
    intersect(dragConstraints, viewport, node, ray) {
        const dragConstraintResults = [];
        for (let d in dragConstraints) {
            const res = dragConstraints[d].intersect(viewport, node, ray);
            if (res)
                dragConstraintResults.push(Object.assign({ dragConstraint: dragConstraints[d] }, res));
        }
        if (dragConstraintResults.length > 0) {
            dragConstraintResults.sort((a, b) => a.distance - b.distance);
            return { dragConstraint: dragConstraintResults[0].dragConstraint, matrix: dragConstraintResults[0].transformation, dragAnchor: dragConstraintResults[0].dragAnchor };
        }
        else {
            return { matrix: gl_matrix_1.mat4.create() };
        }
    }
    /**
     * Setup the drag constraints. This function is called whenever a drag event starts.
     * Returns a transformation matrix with the closest drag constraint.
     *
     * @param dragConstraints
     * @param viewport
     * @param node
     * @param ray
     * @param intersection
     * @returns
     */
    setup(dragConstraints, viewport, node, ray, intersection, previousDragMatrix) {
        const dragConstraintResults = [];
        for (let d in dragConstraints) {
            const res = dragConstraints[d].setup(viewport, node, ray, intersection, previousDragMatrix);
            if (res)
                dragConstraintResults.push(Object.assign({ dragConstraint: dragConstraints[d] }, res));
        }
        if (dragConstraintResults.length > 0) {
            dragConstraintResults.sort((a, b) => a.distance - b.distance);
            return { dragConstraint: dragConstraintResults[0].dragConstraint, matrix: dragConstraintResults[0].transformation, dragAnchor: dragConstraintResults[0].dragAnchor };
        }
        else {
            return { matrix: gl_matrix_1.mat4.create() };
        }
    }
}
exports.DragConstraintUtils = DragConstraintUtils;
//# sourceMappingURL=DragConstraintUtils.js.map